import React from 'react'
import Header from '../../components/global/Header'
import styles from "../../asset/css/daoPage.module.css";
import { Images } from '../../data/Images';
export default function AiPage() {
    return (
        <div className={`${styles.deoPage} ${styles.aiPage} homePagelayout`}>
            <Header />
            <section className={styles.tokenomicsSection}>
                <div className={styles.titlePart}>
                    <h2 className={"madani_arabic_bold"}>AI</h2>
                    <p>
                        AI will enhance Nexus Launchpad by optimizing project discovery, investment decision-making, and security. Here’s how:
                    </p>
                </div>
                <div className={styles.contentPart}>
                    <div className={styles.keyAspectsCardWrapper}>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <h3>Project Vetting & Risk Analysis</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <p>
                                    AI will assess project quality by analyzing on-chain data, team credibility, and historical trends, providing investors with risk scores and insights.
                                </p>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <h3>Smart Matching & Personalization </h3>
                            </div>
                            <div className={styles.cardBody}>
                                <p>
                                    AI-driven recommendation engines will match users with high-quality projects based on their interests, past investments, and risk appetite.
                                </p>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <h3>AI-Powered Tokenomics Modeling</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <p>
                                    AI will simulate different token distribution models and predict outcomes, helping projects optimize their tokenomics for long-term sustainability.
                                </p>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <h3>Fraud Detection & Security</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <p>
                                    AI will monitor transactions and detect suspicious activities, preventing rug pulls and scams.
                                </p>
                            </div>
                        </div>
                        <div className={styles.keyAspectCardPart}>
                            <div className={styles.cardHeader}>
                                <h3>Automated Community Engagement</h3>
                            </div>
                            <div className={styles.cardBody}>
                                <p>
                                    Nexus AI chatbot and assistant will provide real-time updates, answer investor queries, and facilitate engagement in launchpad communities.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.tokenBgPatten}>
                    <img className={styles.aiPattenImg1} src={Images.aiPattenImg1} alt="circle Shape" />
                    <img className={styles.aiPattenImg2} src={Images.aiPattenImg2} alt="circle Shape" />
                    <img className={styles.aiPattenImg3} src={Images.aiPattenImg3} alt="circle Shape" />
                    <img className={styles.aiPattenImg4} src={Images.aiPattenImg4} alt="circle Shape" />
                    <img className={styles.aiPattenImg5} src={Images.aiPattenImg5} alt="circle Shape" />
                </div>
            </section>
        </div>
    )
}
